import { render, staticRenderFns } from "./PaymentReceivableDetails.vue?vue&type=template&id=3364edae"
import script from "./PaymentReceivableDetails.vue?vue&type=script&lang=js"
export * from "./PaymentReceivableDetails.vue?vue&type=script&lang=js"
import style0 from "./PaymentReceivableDetails.vue?vue&type=style&index=0&id=3364edae&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports